module.exports = "<reservation-page></reservation-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/reservation.html
// module id = 1811
// module chunks = 0